<!--
    Summary:
        认证资质
    ChangeLog:
        Labbor on 2020/2/21 added
-->
<template>
  <div class="v-accreditation">
    <banner>
      <img src="../../assets/images/about/Header_1920x380_accreditation.jpg"/>
      <div slot="title">{{$t('Accreditation.Title')}}</div>
    </banner>

    <!-- 被认可的化验所 -->
    <div class="recognized">
      <h2 class="title">{{$t('Accreditation.P1Title')}}</h2>
      <p class="detail">{{$t('Accreditation.P1Detail')}}</p>
      <a target="_blank" href="https://www.smp-council.org.hk/mlt/sc/content.php?page=lcc" class="a-btn">{{$t('Accreditation.P1Button')}}</a>
    </div>

    <!-- 香港少数获ISO认证化验所 -->
    <div class="iso-lab-wrapper">
      <div class="iso-lab">
        <card class="card">
          <div slot="title">{{$t('Accreditation.P2Title')}}</div>
          <div slot="title" v-if="$i18n.locale=='en-US'">{{$t('Accreditation.P2Titles')}}</div>
          
          <p class="detail2">{{$t('Accreditation.P2Detail')}}</p>
          <p>&nbsp;</p>
          <p class="detail2">{{$t('Accreditation.P2Detail2')}}</p>
        </card>
        <div class="img-wrapper" >
          <a target="_blank" href="../../../static/images/fclab-iso9001.jpg">
            <img src="../../assets/images/about/fclab-iso9001.jpg" height="300" width="212"/>
          </a>
        </div>
      </div>
    </div>


    <!-- 关于ISO 9001 -->
    <div class="about-iso-9001-wrapper">
      <div class="about-iso-9001">
        <card class="card">
          <div slot="title">{{$t('Accreditation.P3Title')}}</div>
          <div slot="subtitle">{{$t('Accreditation.P3Title2')}}</div>

          <div class="c">
            <div class="img-wrapper">
              <img src="../../assets/images/about/ISO9001.png" height="111" width="300"/>
            </div>
            <div class="text">
              <p class="detail2">{{$t('Accreditation.P3Detail')}}</p>
              <p>&nbsp;</p>
              <p class="detail2">{{$t('Accreditation.P3Detail2')}}</p>
            </div>
          </div>
        </card>
      </div>
    </div>

    <!-- 殊荣 -->
    <div class="award-wrapper">
      <div class="award">
        <card class="card">
          <div slot="title">{{$t('Accreditation.P4Title')}}</div>
          <p class="detail2">{{$t('Accreditation.P4Detail')}}</p>
          <p>&nbsp;</p>
        </card>
        <div class="img-wrapper" >
          <img src="../../assets/images/carir.png" width="300"/>
        </div>
      </div>
    </div>

<!-- 关于Green office award -->
    <div class="about-iso-9001-wrapper">
      <div class="about-iso-9001">
        <card class="card">
          <div slot="title">{{$t('Accreditation.P5Title')}}</div>
          

          <div class="c">
            <div class="img-wrapper">
              <img src="../../assets/images/about/wgo.png" height="111" width="300"/>
            </div>
            <div class="text">
              <p class="detail2">{{$t('Accreditation.P5Detail')}}</p>
            </div>
          </div>
        </card>
      </div>
    </div>

  </div>
</template>

<script>
  import banner from '@/components/banner'
  import card from '@/components/card'
  import hoverBox from '@/components/hover-box'

  export default {
    components: {
      banner,
      card,
      hoverBox
    },
    data() {
      return {}
    },
    methods: {},
  }
</script>

<style lang="css">
  .v-accreditation .card.v-card .v-card-main {
    width: 100%;
  }
</style>
<style scoped lang="scss">
  .v-accreditation {
    
    .recognized {
      color: #fff;
      padding-top: 60px;
      padding-bottom: 60px;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      background-image: url("../../assets/images/about/accreditation_960x500_-01.jpg");

      .title {
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        text-transform: none;
        margin-bottom: 300px;
      }

      .detail {
        font-size: 16px;
        line-height: 24px;
        font-style: normal;
        font-weight: 400;
        margin-bottom: 30px;
      }
    }

    .iso-lab-wrapper {
      margin-bottom: 30px;
      .iso-lab{
        display: flex;
        width: 1200px;
        margin: 0 auto;

        .card {
          text-align: left;
          width: auto;
        }

        .img-wrapper {
          margin: 60px 80px 30px 115px;
          img{
            border-radius: 0;
            box-shadow: none;
            padding: 6px;
            border: none;
            background-color: #ebebeb;
          }
          a{
            position: relative;
            display: inline-block;
          }
          a:hover{
            &:before{
              opacity: 1;
            }
          }
          a:before{
            content: ' ';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            background-color: rgba(0,0,0,.25);
            transition: opacity .2s ease-out;
          }
        }
      }
    }

    .about-iso-9001-wrapper {
      background-color: rgba(54, 141, 167, 0.15);
      .about-iso-9001 {
        width: 1200px;
        margin: 0 auto;
        padding-bottom: 30px;
        .card {
          text-align: left;
          width: auto;
          .c {
            display: flex;
            align-items: center;
            .img-wrapper {
              margin-right: 30px;
            }
            .text{

            }
          }
        }
      }
    }

    .award-wrapper{
      margin-bottom: 30px;
      .award{
        display: flex;
        width: 1200px;
        margin: 0 auto;
        .card {
          text-align: left;
          width: auto;
        }

        .img-wrapper {
          margin: 90px 80px 0 115px;
          img{
            border-radius: 0;
            box-shadow: none;
            padding: 6px;
            border: none;
          }

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/about/accreditation.vue